import { useState } from 'react'
import { useGenerateReport } from '../hooks/useGenerateReport'
import { useAppState } from '../hooks/useAppState'
import {
  FORM_KEYS,
  FormErrors,
  FormKey,
  validateForm,
} from '../utils/validateForm'
import { parseForm } from '../utils/parseForm'
import { Field } from './Field'
import { Spinner } from './Spinner'
import { useSubmissionId } from '../hooks/useSubmissionId'
import { useError } from '../hooks/useError'

export function Form() {
  const mutation = useGenerateReport()
  const apiError = useError((s) => s.error)
  const [errors, setErrors] = useState<FormErrors<FormKey>>({})
  const setSubmissionId = useSubmissionId((s) => s.setSubmissionId)
  const setStatus = useAppState((s) => s.setStatus)
  const names: FormKey[] = FORM_KEYS
  const isLoading = mutation.isPending
  const params = new URLSearchParams(window.location.search)

  return (
    <form
      noValidate
      onSubmit={(e) => {
        e.preventDefault()
        const elements = e.currentTarget.elements
        const err = validateForm(elements, names)
        setErrors(err)
        if (Object.keys(err).length > 0) return

        const form = parseForm(elements, names)
        mutation.mutate(form, {
          onError: () => setStatus('intake'),
          onSuccess: (response) => {
            setSubmissionId(response.data.submissionId)
            setStatus('pending')
          },
        })
      }}
    >
      <h3 style={{ marginBottom: 12 }}>
        Provide the ASIN for your Amazon Listing
      </h3>
      <Field
        name='item'
        type='text'
        placeholder='ASIN'
        defaultValue={'B07WWKPLGS'}
        label='Amazon ASIN'
        error={errors.item}
        required
        disabled={isLoading}
      />
      <Field
        name='email'
        type='email'
        placeholder='email@company.com'
        defaultValue={params.get('email') ?? undefined}
        description='Provide your work email address so we can send you the full Listing
          Quality report.'
        label='Company Email'
        error={errors.email}
        required
        disabled={isLoading}
        style={{ marginBottom: apiError ? 0 : undefined }}
      />
      {apiError && (
        <span className='error' style={{ margin: '12px 0' }}>
          {apiError}
        </span>
      )}
      <p className='policy' style={{ marginTop: 4 }}>
        By clicking "Get My Report," you acknowledge that your data will be
        handled in accordance with Spreetail's{' '}
        <a
          target='_blank'
          href='https://www.spreetail.com/spreetail-privacy-statement'
        >
          Privacy Policy
        </a>
        , and you authorize Spreetail to send you marketing updates.
      </p>
      <div style={{ marginTop: 4 }}>
        <button type='submit' disabled={isLoading} style={{ display: 'flex' }}>
          {isLoading && (
            <Spinner size={16} stroke={'#0d0e12'} style={{ marginRight: 5 }} />
          )}
          Get My Report
        </button>
      </div>
    </form>
  )
}
